export default __webpack_public_path__ + "static/media/logo-full.cc5036df.png";